import FlowComponent from "ips/ac/Component";
import Util from "ips/ac/util/Util";
import { ValueHelp } from "ips/ac/model/odata/generated/IpsCoreModel";
import JSONModel from "sap/ui/model/json/JSONModel";
import HttpUtil from "ips/ac/util/HttpUtil";
import { WinDoFlowResponseListValueHelpDto } from "ips/ac/model/api/WinDoFlow.api.types";

export default class ValueHelpService {

  public static async refreshValueHelpModel() {
    const component: FlowComponent = Util.getComponent() as FlowComponent;

    const result = await HttpUtil.get("/IpsCore/private/service/value-help") as WinDoFlowResponseListValueHelpDto;
    const valueHelps: ValueHelp[] = result.content.map(context => {
      return {
        Guid: context.guid,
        Id: context.id,
        Value: context.value,
        TextShort: context.textShort,
        TextLong: context.textLong,
        Ranking: context.ranking,
      } as ValueHelp
    });

    const vhModel: JSONModel = component.getModel("SVH") as JSONModel;
    vhModel.setProperty("/", valueHelps);
  }

}
